import FieldType from '@/ecm/variables/FieldType';

export default class Variable {
    constructor(dto) {
        this.id = 0;
        this.name = '';
        this.code = '';
        this.value = '';
        this.type = FieldType.String;

        if (dto) {
            Object.keys(dto).forEach((key) => {
                this[key] = dto[key];
            });
        }
    }
}
